/**
 * @file コンポーネント：価格 ロジック管理
 */

// ライブラリ読み込み
import React from "react";

// 関数読み込み
import { fnGetCultureLanguage } from "~/src/functions/common";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const Price = (props) => {
    /**
     * 価格のカンマ区切り
     */
    const price = props.price.toLocaleString();

    /**
     * 表示言語による表記切り替え（円のみ）
     */
    const language = fnGetCultureLanguage();
    let tax;
    let unit;
    let unitPosition = "left";
    if (language === "ja") {
        tax = "(税込)";
        unit = "円";
        unitPosition = "right";
    } else {
        tax = "(with tax)";
        unit = "&yen;";
    }

    // Presenterに渡す
    return (
        <Presenter
            isPurchased={props.isPurchased}
            price={price}
            tax={tax}
            unit={unit}
            unitPosition={unitPosition}
        />
    );
};
